export interface SalesDespatchProductReport {
  productKey: string;
  productDescription: string;
  grossQuantity: number;
  nettQuantity: number;
  noOfItems: number;
  unitOfMeasure: string;
}
